import bridge from '@vkontakte/vk-bridge';
import { createEffect } from 'effector';
import { IImageStatus } from '../../../model/types';

export const getCurrentUserStatusFx = createEffect<string, IImageStatus, Error>(async $userAccessToken => {
  try {
    const { response } = await bridge.send(
      'VKWebAppCallAPIMethod',
      {
        method: 'status.getImage',
        params: {
          v: '5.131',
          access_token: $userAccessToken
        }
      }
    );

    if (!response) {
      throw new Error('Ошибка получения списка статусов');
    }

    return response.status as IImageStatus;
  } catch (error) {
    throw new Error(String(error));
  }
});
